import React from 'react'
import ManageContent from './ManageContent'

export default function ManagePage () {
  return (
    <div className='helpPage mobile'>
      <ManageContent isMobile={true} />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/privacy_center/manage/ManageMobile.jsx